import { useEffect } from 'react';

import flowLinkedTextsOperation from 'editor/src/store/design/operation/flowLinkedTextsOperation';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

/**
 * Keeps the text of linked frames flowing. Any design change may move text between
 * frames (typing, a style, the text library, a resized frame), and so may a font that finishes
 * loading or the end of typing in a frame; the operation is a no-op for designs without links.
 */
function useTextFlowWatcher() {
  const dispatch = useDispatch();
  const designData = useSelector((state) => state.design.designData);
  const availableFonts = useSelector((state) => state.fonts.availableFonts);
  const textEditMode = useSelector((state) => state.editor.textEditMode);

  useEffect(() => {
    dispatch(flowLinkedTextsOperation());
  }, [designData, availableFonts, textEditMode]);
}

export default useTextFlowWatcher;
